export const BEGIN_STEP = "BEGIN_STEP";
export const BEGIN_NEXT_STEP = "BEGIN_NEXT_STEP";
export const BEGIN_PREVIOUS_STEP = "BEGIN_PREVIOUS_STEP";
export const SET_STEP_DATA = "SET_STEP_DATA";
export const SET_PAGE_LOADING = "SET_PAGE_LOADING";

// Working area actions
export const ADD_WORKING_AREA_SPECIFICATION = "ADD_WORKING_AREA_SPECIFICATION";
export const REMOVE_WORKING_AREA_SPECIFICATION = "REMOVE_WORKING_AREA_SPECIFICATION";
export const CLEAR_WORKING_AREA_SPECIFICATIONS = "CLEAR_WORKING_AREA_SPECIFICATIONS";
